var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIndustry = function SvgIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.826 4.073H7.902a.674.674 0 00-.674.673v5.356h-1.19c-1.4 0-2.538 2.138-2.538 3.537v3.75a2.54 2.54 0 002.875 2.516h11.116c1.659 0 3.009-1.35 3.009-3.01V4.747a.674.674 0 00-.674-.673zM7.228 17.39c0 .577-.414 1.06-.96 1.168h-.23v.022c-.657 0-1.19-.534-1.19-1.19v-3.75c0-.657.533-1.19 1.19-1.19h1.19v4.94zm11.925-.494c0 .9-.761 1.662-1.662 1.662h-9.2c.181-.35.284-.747.284-1.168V5.42h10.578v11.476z"
  })));
};

export default SvgIndustry;